import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FileUploadModule } from 'ng2-file-upload';
import { LocalizationModule } from 'angular-l10n';

import { AppUploadFileComponent } from './app-upload-file.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FileUploadModule,
    LocalizationModule
  ],
  declarations: [AppUploadFileComponent],
  exports: [
    FileUploadModule,
    AppUploadFileComponent,
    LocalizationModule
  ]
})
export class AppUploadFileModule { }



// WEBPACK FOOTER //
// ./src/app/components/app-upload-file/app-upload-file.module.ts